import * as React from "react";
import { observer } from "mobx-react";
import { MDBCol, MDBRow } from "mdbreact";
import { FormGroup, HTMLSelect, InputGroup, Tab, Tabs } from "@blueprintjs/core";
import { observable } from "mobx";
import { SpedEfdStore } from "../../stores/sped/SpedEfdStore";

import CfopSaida from "./cfop_saida";
import CfopEntrada from "./cfop_entrada";
import ImportCfops from "./import_cfops";
import { newEmpresa } from "../../model";

@observer
export default class ConfiguracaoImportacaoCte extends React.Component<{}, {}> {

    obs = observable({
        select_config_saidas_tab: "opcoes" as string,
        select_config_entradas_tab: "opcoes" as string,
        open_select_import_saida: false as boolean,
        open_select_import_entrada: false as boolean,
    })

    constructor(props: any) {
        super(props);
    }

    async hanldeChangeTabConfig(tab: string) {
        this.obs.select_config_saidas_tab = "opcoes";
        this.obs.select_config_entradas_tab = "opcoes";
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "saida") {
            await SpedEfdStore.loadSped(SpedEfdStore.obs.selectedEmpresa.cnpj, tab, "cte")
            SpedEfdStore.obs.tab_entrada_saida = tab;
            SpedEfdStore.obs.entrada_saida = "saida"
        }

        else if (tab == "entrada") {
            await SpedEfdStore.loadSped(SpedEfdStore.obs.selectedEmpresa.cnpj, tab, "cte")
            SpedEfdStore.obs.tab_entrada_saida = tab;
            SpedEfdStore.obs.entrada_saida = "entrada"

        } else {
            SpedEfdStore.obs.tab_entrada_saida = tab;
        }
    }

    async hanldeChangeTabSaida(tab: string) {
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "cfops") {
            await SpedEfdStore.loadCfops("saida", 1, SpedEfdStore.obs.config_id)
            this.obs.select_config_saidas_tab = tab;
        }
        else if (tab == "import") {
            this.obs.open_select_import_saida = true
        }
        else {
            this.obs.select_config_saidas_tab = tab;
        }
    }

    async hanldeChangeTabEntrada(tab: string) {
        SpedEfdStore.obs.cfops_current = 1

        if (tab == "cfops") {
            await SpedEfdStore.loadCfops("entrada", 1, SpedEfdStore.obs.config_id)
            this.obs.select_config_entradas_tab = tab;
        }
        else if (tab == "import") {
            this.obs.open_select_import_entrada = true
        }
        else {
            this.obs.select_config_entradas_tab = tab;
        }
    }

    async handleImportNotas(e: boolean) {
        SpedEfdStore.obs.sped.import_notas = e

        let params = {
            import_notas: e,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    async handleGerarInformacoes(e: any) {
        if (SpedEfdStore.obs.sped.gerar_informacoes) {
            SpedEfdStore.obs.sped.informacoes_conforme = "nota"
        } else {
            SpedEfdStore.obs.sped.informacoes_conforme = ""
        }

        let params = {
            gerar_informacoes: SpedEfdStore.obs.sped.gerar_informacoes,
            informacoes_conforme: SpedEfdStore.obs.sped.informacoes_conforme,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }


    async handleDeduzirIcms(e: boolean) {
        SpedEfdStore.obs.sped.deduzir_icms = e

        let params = {
            deduzir_icms: e,
            id: SpedEfdStore.obs.config_id
        }

        await SpedEfdStore.handleSaveSped(params)
    }

    onClose() {
        this.obs.open_select_import_entrada = false
        this.obs.open_select_import_saida = false
        SpedEfdStore.obs.selectedEmpresaImport = newEmpresa()
        SpedEfdStore.obs.modelo = "selecione"
    }

    render() {

        return (
            <>
                <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={SpedEfdStore.obs.tab_entrada_saida}
                    onChange={(tabId) => this.hanldeChangeTabConfig(String(tabId))}
                >
                    <Tab
                        id="geral"
                        title="Geral"
                        panel={
                            <MDBCol>
                                <h4 className="sub-title-sped">Modelo documento</h4>
                                <MDBCol md="12">
                                        <FormGroup label="Espécie CT-e">
                                            <MDBRow>
                                                <MDBCol md="1">
                                                    <InputGroup
                                                        value="57"
                                                        disabled
                                                        type="text" />
                                                </MDBCol>
                                                <MDBCol md="3">
                                                    <InputGroup
                                                        disabled
                                                        value={"Conhecimento de Transporte Eletrônico (CT-e)"}
                                                        type="text" />
                                                </MDBCol>
                                            </MDBRow>
                                        </FormGroup>

                                        <FormGroup label="Espécie CTe OS">
                                            <MDBRow>
                                                <MDBCol md="1">
                                                    <InputGroup
                                                        value="67"
                                                        disabled
                                                        type="text" />
                                                </MDBCol>
                                                <MDBCol md="3">
                                                    <InputGroup
                                                        disabled
                                                        value={"Conhecimento de Transporte Eletrônico para Outros Serviços (CTe OS)"}
                                                        type="text" />
                                                </MDBCol>
                                            </MDBRow>
                                        </FormGroup>
                                </MDBCol>
                            </MDBCol>
                        }
                    />

                    <Tab
                        id="saida"
                        title="Saídas"
                        panel={
                            <>
                                <Tabs
                                    id="tabsS"
                                    className={"tabsCalculos"}
                                    selectedTabId={this.obs.select_config_saidas_tab}
                                    onChange={(tabId) => this.hanldeChangeTabSaida(String(tabId))}
                                >
                                    <Tab
                                        id="opcoes"
                                        title="Opções"
                                        panel={
                                            <>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="gerar_info"
                                                                name="gerar_info"
                                                                onChange={(e) => this.handleGerarInformacoes(SpedEfdStore.obs.sped.gerar_informacoes = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.gerar_informacoes}
                                                            />
                                                            <label htmlFor="gerar_info" className="label-feriados">Gerar informações complementares no SPED conforme informado nas notas fiscais.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                            </>
                                        }
                                    />

                                    <Tab
                                        id="cfops"
                                        title="CFOPs"
                                        panel={
                                            <CfopSaida />
                                        }
                                    />
                                    <Tab
                                        id="import"
                                        title="Importar"
                                        panel={
                                            <ImportCfops isOpen={this.obs.open_select_import_saida} onClose={this.onClose.bind(this)} />
                                        }
                                    />
                                </Tabs>
                            </>
                        }
                    />

                    <Tab
                        id="entrada"
                        title="Entradas"
                        panel={
                            <>
                                <Tabs
                                    id="tabsS"
                                    className={"tabsCalculos"}
                                    selectedTabId={this.obs.select_config_entradas_tab}
                                    onChange={(tabId) => this.hanldeChangeTabEntrada(String(tabId))}
                                >
                                    <Tab
                                        id="opcoes"
                                        title="Opções"
                                        panel={
                                            <>
                                                <MDBCol md="12" style={{ marginTop: "20px" }}>
                                                    <MDBCol>
                                                        <MDBRow>
                                                            <input
                                                                type="checkbox"
                                                                className="chaves"
                                                                id="gerar_info"
                                                                name="gerar_info"
                                                                onChange={(e) => this.handleGerarInformacoes(SpedEfdStore.obs.sped.gerar_informacoes = e.target.checked)}
                                                                checked={SpedEfdStore.obs.sped.gerar_informacoes}
                                                            />
                                                            <label htmlFor="gerar_info" className="label-feriados">Gerar informações complementares no SPED conforme informado nas notas fiscais.</label>
                                                        </MDBRow>
                                                    </MDBCol>
                                                </MDBCol>
                                            </>
                                        }
                                    />

                                    <Tab
                                        id="cfops"
                                        title="CFOPs"
                                        panel={
                                            <CfopEntrada />
                                        }
                                    />
                                    <Tab
                                        id="import"
                                        title="Importar"
                                        panel={
                                            <ImportCfops isOpen={this.obs.open_select_import_entrada} onClose={this.onClose.bind(this)} />
                                        }
                                    />
                                </Tabs>
                            </>
                        }
                    />
                </Tabs>
            </>
        )
    }
}